import React, { createContext, useContext, useState } from 'react';

const ToastContext = createContext();

export function useToast() {
    return useContext(ToastContext);
}

export function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]);

    const showToast = (message, type = 'info', duration = 5000) => {
        const id = Math.random().toString(36).substr(2, 9);
        const toast = { id, message, type };
        setToasts((prev) => [...prev, toast]);

        setTimeout(() => {
            removeToast(id);
        }, duration);
    };

    const removeToast = (id) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    };

    const value = {
        showToast,
    };

    return (
        <ToastContext.Provider value={value}>
            {children}
            <ToastContainer toasts={toasts} removeToast={removeToast} />
        </ToastContext.Provider>
    );
}

function ToastContainer({ toasts, removeToast }) {
    if (toasts.length === 0) return null;

    return (
        <div className='toast-container'>
            {toasts.map((toast) => (
                <div key={toast.id} className={`toast ${toast.type}`}>
                    <div className='toast-header'>
                        <div className='toast-title'>
                            {toast.type.charAt(0).toUpperCase() +
                                toast.type.slice(1)}
                        </div>
                        <button
                            onClick={() => removeToast(toast.id)}
                            className='modal-close'
                        >
                            ×
                        </button>
                    </div>
                    <div className='toast-body'>{toast.message}</div>
                </div>
            ))}
        </div>
    );
}
